import { UserLangService } from 'src/app/services/common/user-lang/user-lang.service';
import { AfterViewInit, Component,  OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { DateUtils } from 'src/app/utils/date-utils';
import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../main/main.component';
import { environment } from 'src/environments/environment';
import { MapComponent, MapLatLng, MapMarker } from 'movisat-maps';
import { MapClusterV2 } from 'movisat-maps';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { NzModalComponent, NzModalService } from 'ng-zorro-antd/modal';
import { PuService } from 'src/app/services/pu/pu.service';
import { BdtService } from 'src/app/services/bdt/bdt.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { ElementsService } from 'src/app/services/elements/elements.service';

import { ElementoModel } from 'src/app/services/elements/models/elem.model';

import { ElementsEditComponent } from './elements-edit/elements-edit.component';
import { ElementsCercaComponent } from './elements-cerca/elements-cerca.component';
import { Utils } from 'src/app/utils/utils';
import { ElemCoordenadasModel } from 'src/app/services/elements/models/elem-coordenadas.model';
import { ElementsEditHistoricoCoordenadasComponent } from './elements-edit/elements-edit-historico-coordenadas/elements-edit-historico-coordenadas.component';
import { BdtCatalogoEquipamientoModel } from 'src/app/services/bdt/models/bdt-catalogo-equipamiento.model';
import { ElementInstallOptionsComponent } from './element-install-options/element-install-options.component';
import { InstalacionService } from 'src/app/services/elements/instalacion/instalacion.service';
import { combineLatest, from, switchMap} from 'rxjs';
import { ExportService } from 'src/app/services/export/export.service';

export enum VISTAS {
  NORMAL = 0,
  ECOLOCK = 1,
}

@Component({
  selector: 'app-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.css']
})
export class ElementsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('modalBorrar') modalBorrar: NzModalComponent;
  @ViewChild('gridElements') gridElements: jqxGridComponent;
  @ViewChild('elementsEdit', { read: ViewContainerRef }) elementsEdit;
  @ViewChild('elementsContainer', { read: ViewContainerRef }) elementsContainer;

  protected vista = VISTAS.NORMAL;

  private visibleColumns = [];

  protected modalVisible = false;
  protected elementToDelete = null;

  private openCreateComponent: ElementsEditComponent | null = null;

  private static instance: ElementsComponent;
  public environment = environment;
  private elemSelec: ElementoModel = null;
  private searchText = '';
  private timerSearch = null;
  private initialFilter: any = null;
  public elementListTotal: ElementoModel[] = [];
  public elementList: ElementoModel[] = [];
  public elementListEcolockView: ElementoModel [] = [];
  private map: MapComponent;
  private orderBy = 'marca,asc';
  private equipModelFilter: any[] = [];
  private oldFilter: any = null;
  private equipModelFilterIA: any[] = [];
  public canEdit = true;
  private toolbarOk = false;
  private MARKERS_ZOOM = 18; // Nivel de zoom al que se ven los marcadores
  public elemCluster: MapClusterV2;
  private canMove = false;
  private distCerca = 0;

  // Subscripciones
  private subscriptionOnAddElements: any = null;
  private subscriptionOnModifyElements: any = null;
  private subscriptionOnDeleteElements: any = null;
  private subscriptionOnChangeFilterElements: any = null;
  private subscriptionOnEndLoadElements: any = null;
  private subscriptionOnNewElements: any = null;
  private subscriptionOnModifyPU: any = null;

  // Varibles para el datagrid
  public showLoader: boolean = true;
  private clickTimer: any;

  // Pongo por defecto los textos en los controles del grid en español
  public langGrid = JqWidgets.getLocalization('es');
  equipamientosDisponibles: BdtCatalogoEquipamientoModel[] = [];
  isProcessing: boolean = false;

  constructor(
    private configService: ConfigService,
    private elementsService: ElementsService,
    private modal: NzModalService,
    private puService: PuService,
    private userLangService: UserLangService,
    private instalacionService: InstalacionService,
    private exportService: ExportService
  ) {
    ElementsComponent.instance = this;
  }

  protected get getVistas(): typeof VISTAS {
    return VISTAS;
  }

  public static getInstance(): ElementsComponent {
    return ElementsComponent.instance;
  }

  public async ngOnInit(): Promise<void> {
    this.canEdit = true; // TODO: por hacer...
    // Cargo el idioma para los componentes jqwidgets
    this.langGrid = JqWidgets.getLocalization(this.userLangService.getUserLangShort());
    // Recupero el nivel de zoom configurado
    this.MARKERS_ZOOM = Number.parseInt(await this.configService.getEmpApp('elements-zoom', '' + this.MARKERS_ZOOM));
    // Recupero los elementos
    this.elementsService.getElements();

    // Me subscribo a eventos
    this.subscribeOnAddElements();
    this.subscribeOnEndLoadElements();
    this.subscribeOnNewElements();
    this.subscribeModifyElements();
    this.subscribeDeleteElements();
    this.subscribeChangeFilterElements();
    this.subscribeModifyPU();
  }

  // Inicializo el toolbar y preparo el grid
  public async ngAfterViewInit(): Promise<void> {
    // Recupero el filtro almacenado si lo hay
    this.getInitFilter();

    // Espera a que el mapa esté listo para empezar a descargar los elementos
    this.map = MainComponent.getInstance().getMap();

    MainComponent.getInstance().mapIsReady
    .subscribe((map) => {
      this.map = map;

      this.map.subscribeOnMarkerClick(this, this.onMarkerClick);
      this.map.subscribeOnMarkerDragEnd(this, this.onMarkerDragEnd);

      this.elemCluster = this.map.addClusterV2(this.MARKERS_ZOOM);
    });
  }

  renderFechaLectura = (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string => {
    if (columnfield == "fechaLectura") {
      const comparisonDate = new Date("Mon Jan 01 0001 00:00:00 GMT-0014");
      if (rowdata.fechaLectura.getTime() !== comparisonDate.getTime() && rowdata.reqVolumetrico !== null) {
        return;
      } else {
        return "";
      }
    }
  }

  rendexTextGeneric = (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string => {
    return (
      `
        <div style="margin-left: 4px; margin-top: 5px;  text-align: left"
          onmouseover="this.style.backgroundColor='gray'; this.style.color='white'; this.style.position='fixed'"
          onmouseout="this.style.backgroundColor=''; this.style.color=''; this.style.position=''"
        >
          ${value}
        </div>
      `
    );
  }

  returnText(value: string): string {
    return (
      `
        <div style="margin-left: 4px; margin-top: 5px;  text-align: left"
          onmouseover="this.style.backgroundColor='gray'; this.style.color='white'; this.style.position='fixed'"
          onmouseout="this.style.backgroundColor=''; this.style.color=''; this.style.position=''"
        >
          ${value}
        </div>
      `
    )
  }

  returnNumber(value: string): string {
    return (
      `
        <div style="margin-right: 4px; margin-top: 5px; text-align: right
          onmouseover="this.style.backgroundColor='gray'; this.style.color='white'; this.style.position='fixed'"
          onmouseout="this.style.backgroundColor=''; this.style.color=''; this.style.position=''"
        >
          ${value}
        </div>
      `
    )
  }

  private cellClass = (row: number, columnfield: any, value: any): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  }

  protected columns = [
    {
      text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', hidden: true,
    },
    {
      text: 'EqId', columntype: 'textbox', filtertype: 'textbox', datafield: 'eqId', hidden: true
    },
    {
      text: this.translate('Acciones'),
      width: 95,
      columntype: 'text',
      sortable: false,
      editable: false,
      datafield: 'acciones',
      groupable: false,
      menu: false,
      exportable: false,
      rendered: (columnHeaderElement) => {
        return columnHeaderElement[0];
      },
      createwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement
      ): void => {
        this.initBtnColumn(row, column, value, htmlElement);
      },
      initwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement
      ) => {
        this.initBtnColumn(row, column, value, htmlElement);
      }
    },
    {
      text: AppComponent.translate('Icono'), columntype: 'textbox', width: 16,
      datafield: 'icono',
      filterable: false,
      sortable: false,
      exportable: false,
      cellsrenderer: this.imagerenderer,
    },
    {
      text: AppComponent.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion', width: 100,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Marca'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'marca', width: 80, cellsrenderer: this.rendexTextGeneric,
      hidden: true,
    },
    {
      text: AppComponent.translate('Modelo'), columntype: 'textbox', filtertype: 'textbox', datafield: 'modelo', width: 90,
      hidden: true, cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Residuo'), columntype: 'textbox', filtertype: 'textbox', datafield: 'residuo', width: 90,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Clases'), columntype: 'textbox', datafield: 'clases', width: 80,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Volumetrico'), columntype: 'textbox', datafield: 'reqVolumetrico', width: 120, hidden: true,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Nivel'), columntype: 'textbox', filtertype: 'textbox', datafield: 'volumetrico', width: 70, hidden: true,
      cellsrenderer: this.volumRender, cellsalign: 'right'
    },
    {
      text: AppComponent.translate('Fecha_lectura'), columntype: 'datetimeinput', filtertype: 'date', datafield: 'fechaLectura', width: 140, hidden: true,
      cellsformat: 'dd/MM/yyyy HH:mm:ss', cellsrenderer: this.renderFechaLectura, cellclassname: this.cellClass,
    },
    {
      text: AppComponent.translate('Tag'), columntype: 'textbox', datafield: 'reqTag', width: 60, hidden: true,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Matricula'), columntype: 'textbox', filtertype: 'textbox', datafield: 'tag', width: 100, hidden: true,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Ecolock_NSFabr'), columntype: 'textbox', datafield: 'ecoNsFabricante', width: 90, hidden: true,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('Ecolock_NSMov'), columntype: 'textbox', datafield: 'ecoNsMovisat', width: 90, hidden: true,
      cellsrenderer: this.rendexTextGeneric
    },
    {
      text: AppComponent.translate('F_ult_conex'), columntype: 'datetimeinput', filtertype: 'date', datafield: 'ecolock', width: 140, hidden: true,
      cellsformat: 'dd/MM/yyyy HH:mm:ss', cellclassname: this.cellClass,
    },
    {
      text: AppComponent.translate('Distancia'), columntype: 'textbox', filtertype: 'textbox', datafield: 'distancia', width: 100,
      hidden: true, align: 'center', cellsalign: 'center', sortable: true,
      aggregates: [{
        'Cerca': function (aggregatedValue: any, currentValue: number, column: number, record: any) {
          let val = undefined;
          if (record['distancia']) {
            const v = record['distancia'].replace(',', '.').replace('km', '').replace('m', '').replace(' ', '');
            val = record['distancia'].indexOf('km') > -1 ? Number.parseFloat(v) * 1000 : Number.parseFloat(v);
          }
          return val <= ElementsComponent.getInstance().distCerca ? aggregatedValue + 1 : aggregatedValue;
        }
      },
      {
        'Lejos': function (aggregatedValue: any, currentValue: number, column: number, record: any) {
          let val = undefined;
          if (record['distancia']) {
            const v = record['distancia'].replace(',', '.').replace('km', '').replace('m', '').replace(' ', '');
            val = record['distancia'].indexOf('km') > -1 ? Number.parseFloat(v) * 1000 : Number.parseFloat(v);
          }
          return val > ElementsComponent.getInstance().distCerca ? aggregatedValue + 1 : aggregatedValue;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Cerca"] !== undefined) {
          renderstring += '<div style="text-align: center;">' + aggregates["Cerca"] + '/' + aggregates["Lejos"] + '</div>';
        }
        return renderstring;
      },
      cellsrenderer: (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any) => {
        if (value) {
          const v = value.replace(',', '.').replace('km', '').replace('m', '').replace(' ', '');
          const val = value.indexOf('km') > -1 ? Number.parseFloat(v) * 1000 : Number.parseFloat(v);
          if (val <= this.distCerca) {
            return '<div style="text-align: center; margin-top: 4px; background-color: #93fc93;">' + value + '</div>';
          }
        }
        return '<div style="text-align: center; margin-top: 4px; background-color: #F96a6a;">' + value + '</div>';
      },
      rendergridrows: (params => {
        const data = generatedata(params.startindex, params.endindex);
        return "";
      }),
    },
    { text: this.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'calle', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Codigo_postal'), columntype: 'textbox', filtertype: 'textbox', datafield: 'codigoPostal', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Poblacion'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'poblacion', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Municipio'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'municipio', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Provincia'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'provincia', width: 100, cellclassname: this.cellClass },
    { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true }
  ];

  protected source = {
    datatype: 'json',
    groupsrenderer: this.groupsrenderer,
    datafields: [
      { name: 'id', type: 'number', map: 'Id' },
      { name: 'eqId', type: 'number', map: 'Equipamiento>Modelo>Id' },
      { name: 'icono', type: 'string', map: 'Equipamiento>Icono' },
      { name: 'descripcion', type: 'string', map: 'Nombre' },
      { name: 'marca', type: 'string', map: 'Equipamiento>Marca>Nombre' },
      { name: 'modelo', type: 'string', map: 'Equipamiento>Modelo>Nombre' },
      { name: 'residuo', type: 'string', map: 'Equipamiento>ResiduosNombres' },
      { name: 'clases', type: 'string', map: 'Equipamiento>ClasesNombre' },
      { name: 'reqVolumetrico', type: 'string', map: 'Volumetrico>NombreDispositivo' },
      { name: 'fechaLectura', type: 'date', map: 'UltFechaVolum' },
      { name: 'volumetrico', map: 'UltPctjeVolum' },
      { name: 'reqTag', type: 'string', map: 'Tag>Tag' },
      { name: 'tag', map: 'Tag>Matricula' },
      { name: 'ecoNsFabricante', type: 'string', map: 'cerradura>nsFabricante' },
      { name: 'ecoNsMovisat', type: 'string', map: 'cerradura>nsMovisat' },
      { name: 'ecolock', type: 'date', map: 'cerradura>fechaUltimaConexion' },
      { name: 'distancia', map: 'distancia' },
      { name: 'calle', map: 'Calle' },
      { name: 'codigoPostal', map: 'CodigoPostal', type: 'string' },
      { name: 'comunidadAutonoma', map: 'ComunidadAutonoma' },
      { name: 'municipio', map: 'Municipio' },
      { name: 'numeroCalle', map: 'NumeroCalle', type: 'number' },
      { name: 'pais', map: 'Pais' },
      { name: 'poblacion', map: 'Poblacion' },
      { name: 'provincia', map: 'Provincia' },
      { name: 'selec', map: 'selec' }
    ],
    localdata: [],
  };

  public dataAdapter = new jqx.dataAdapter(this.source);

  imagerenderer(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value && value.length > 50) {
      return (
        `<div style="display: flex; justify-content: center; align-items: center;">
          <img style="margin-left: 4px; margin-top: 5px;" height="16" width="16" src="data:image/jpg;base64,${value}"/>
        </div`
      );
    } else {
      return (
        '<div style="margin-left: 4px; margin-top: 5px;"></div>'
      );
    }
  }

  clasesRender(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      let textToShow = '';
      value.forEach(element => {
        textToShow += textToShow == '' ? element.Nombre : ', ' + element.Nombre;
      });
      return this.returnText(textToShow);
    } else {
      return (
        '<div style="margin-left: 4px; margin-top: 5px;"></div>'
      );
    }
  }

  volumRender(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (rowdata.reqVolumetrico) {
      try {
        return `<div class="jqx-grid-cell-right-align" style="margin-left: 4px; margin-top: 5px;">${this.returnNumber(value + " %")}</div>`
      } catch (error) {
      }
    } else {
      return (
        '<div class="jqx-grid-cell-right-align" style="margin-left: 4px; margin-top: 5px;"></div>'
      );
    }
  }

  dateRender(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value) {
      let date = new Date(value);
      try {
        return this.returnText(DateUtils.formatDate(date, true) + ` ` + DateUtils.formatTime(date))
      } catch (error) {
      }
    } else {
      return (
        '<div class="jqx-grid-cell-left-align" style="margin-top: 4px;"></div>'
      );
    }
  }

  // Incializa la columna de botones
  async initBtnColumn(row: any, column: any, value: string, htmlElement: HTMLElement) {
    // Limpiar el contenedor antes de añadir nuevos elementos
    htmlElement.innerHTML = '';

    // Crea un contenedor para los botones
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.justifyContent = 'flex-start';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';

    // Obtener datos del elemento una sola vez al inicio
    let rowdata = row && isNaN(row) ? row.bounddata : ElementsComponent.getInstance().gridElements.getrowdata(row);
    let element = ElementsComponent.getInstance().elementList.find(e => e.Id == rowdata.id);

    // **Botón Editar**
    const btnEdit = document.createElement('div');
    btnEdit.innerHTML = `
        <button class="button" style="height: 23px; cursor: pointer;" title="${AppComponent.translate('Editar')}">
          <i class="fa-solid fa-pen-to-square"></i>
        </button>
      `;
    btnContainer.appendChild(btnEdit);

    // Evento click para editar
    btnEdit.onclick = async () => {
      this.checkEditingElement(element);
    };

    // **Botón Posicionar**
    const btnPosicionar = document.createElement('div');
    btnPosicionar.innerHTML = `
      <button class="button" style="height: 23px; cursor: pointer;" title="${AppComponent.translate('Posicionar')}">
        <i class="fa-solid fa-location-dot"></i>
      </button>
    `;
    btnContainer.appendChild(btnPosicionar);

    // Evento click para posicionar
    btnPosicionar.onclick = () => {
      if (!element.Marker) {
        element.Marker = this.addMarker(element);
      }
      this.map.setCenter(element.Marker.position);
      this.map.setZoom(this.MARKERS_ZOOM);
      element.Marker.setZIndex(999);
      element.Marker.animate(1500);
    };

    // **Condición para mostrar el botón Borrar**
    if (!element?.Volumetrico && !element?.Tag && element?.cerradura?.id === 0) {
      const btnDelete = document.createElement('div');
      btnDelete.innerHTML = `
          <button class="button" style="height: 23px; cursor: pointer;" title="${AppComponent.translate('Borrar')}">
            <i class="fa-solid fa-trash"></i>
          </button>
        `;
      btnContainer.appendChild(btnDelete);

      // Evento click para borrar
      btnDelete.onclick = async () => {
        // Clonar el objeto `element` para evitar perder la referencia
        this.elementToDelete = { ...element };

        try {
          const result = await this.elementsService.getResiduoPendiente(this.elementToDelete.Id);
          if (result.id) {
            MainComponent.getInstance().showWarning('ATENCION', 'Elemento_con_residuo', 3000, ' ' + this.elementToDelete.Nombre);
          } else {
            this.modalVisible = true;
          }
        } catch (error) {
          console.error("Error al intentar borrar el elemento:", error);
        }
      };
    }

    // Agregar el contenedor de botones al HTML del grid
    htmlElement.appendChild(btnContainer);
  }

  async deleteElement() {
    await this.elementsService.deleteElemento(this.elementToDelete);
    MainComponent.getInstance().showSuccess('ATENCION', 'Registro_borrado', 2000);
    this.gridElements.clearselection();
    this.closeModalDeleteElement();
  }

  async deleteElementWithPU() {
    await this.elementsService.deleteElemento(this.elementToDelete).then(
      async (result: Boolean) => {
        if (!result) return;

        await this.puService.deletePU(this.elementToDelete.PU);
      }
    );
    MainComponent.getInstance().showSuccess('ATENCION', 'Registro_borrado', 2000);
    this.gridElements.clearselection();
    this.closeModalDeleteElement();
  }

  closeModalDeleteElement() {
    this.modalVisible = false;
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any) {
  }

  // Para traducir los textos del template
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  showHideColums() {
    try {
      this.gridElements.showcolumn('marca');
    } catch (e) {
    }

    try {
      this.gridElements.showcolumn('modelo');
    } catch (e) {
    }

    try {
      this.gridElements.showcolumn('tipo');
    } catch (e) {
    }

    try {
      this.gridElements.showcolumn('capacidad');
    } catch (e) {
    }
  }

  onRowClick(event: any) {
    this.gridElements.selectedrowindex(event.args.rowindex);
  }

  // Cuando se pincha sobre un elemento
  onMarkerClick(_this: any, marker: MapMarker) {
    // Compruebo que se trata de un elemento
    if (marker.dataModel.hasOwnProperty('IdPU')) {
      // Busco el elemento en el grid y lo selecciono
      const rows = _this.gridElements.getrows();
      if (rows) {
        rows.forEach(async (row, i) => {
          if (row.id === marker.dataModel.Id) {
            _this.gridElements.ensurerowvisible(i);
            const event = {
              args: {
                rowindex: row.dataindex ? row.dataindex : row.boundindex,
                fromCarto: true
              }
            }
            _this.onRowClick(event);
            // Añado la información del punto de ubicación si todavía no está
            if (marker.content.indexOf('#PU') < 0) {
              const elem: ElementoModel = await _this.elementsService.elementos.get(marker.dataModel.Id);
              if (elem && elem.PU) {
                let content = marker.content + '<br>' + elem.PU.Nombre +
                  '<div style="display: none;">#PU</div>';
                marker.setContent(content);
              }
            }
          }
        });
      }
    } else {
      if (marker.dataModel.hasOwnProperty('numElements')) { // Un cluster
        _this.map.setCenter(marker.position);
        _this.map.setZoom(_this.map.zoom < _this.MARKERS_ZOOM - 2 ? _this.map.zoom + 2 : _this.MARKERS_ZOOM);
      }
    }
  }

  // Cuando se arrastra un elemento
  onMarkerDragEnd(_this: any, marker: MapMarker) {
    // Compruebo que se trata de un elemento
    if (marker.dataModel.hasOwnProperty('IdPU')) {
      // Sólo me interesan los elementos que ya existen, los nuevos no
      if (marker.dataModel.Id > 0) {
        if (!MainComponent.getInstance().controlAmbitoActividad(marker.position)) {
          MainComponent.getInstance().showError('ATENCION', 'Fuera_ambito', 2000);
          for (let i = 0; i < _this.elementList.length; i++) {
            if (_this.elementList[i].Id === marker.dataModel.Id) {
              marker.setPosition(new MapLatLng(_this.elementList[i].Lat, _this.elementList[i].Lng));
              break;
            }
          }
        } else {
          _this.modal.confirm({
            nzTitle: '<i>' + AppComponent.translate('ATENCION') + '</i>',
            nzContent: AppComponent.translate('Quiere_mover_elemento') + ': ' + marker.dataModel.Nombre + ' ?',
            nzCentered: true,
            nzCancelText: AppComponent.translate('CANCELAR'),
            nzOkText: AppComponent.translate('SI'),
            nzOnOk: async () => {
              let i = 0;
              for (; i < _this.elementList.length; i++) {
                if (_this.elementList[i].Id === marker.dataModel.Id) {
                  _this.elementList[i].Lat = marker.position.lat;
                  _this.elementList[i].Lng = marker.position.lng;
                  marker.setZIndex(999);
                  break;
                }
              }
              let res = await _this.elementsService.saveElemento(_this.elementList[i])
              if (res) {
                if (ElementsEditComponent &&
                  ElementsEditComponent._this &&
                  ElementsEditComponent._this.elemEdit
                ) {
                  let newCoordinate: ElemCoordenadasModel = new ElemCoordenadasModel();
                  newCoordinate.Calle = res.Calle;
                  newCoordinate.CodigoPostal = res.CodigoPostal;
                  newCoordinate.ComunidadAutonoma = res.ComunidadAutonoma;
                  newCoordinate.Empresa = res.Empresa;
                  newCoordinate.Fecha = res.FechaModificacion;
                  newCoordinate.GuidElemento = res.GuidElemento;
                  newCoordinate.Id = res.Id;
                  newCoordinate.IdElemento = res.IdElemento;
                  newCoordinate.Lat = res.Lat;
                  newCoordinate.Lng = res.Lng;
                  newCoordinate.Municipio = res.Municipio;
                  newCoordinate.NumeroCalle = res.NumeroCalle;
                  newCoordinate.Pais = res.Pais;
                  newCoordinate.Poblacion = res.Poblacion;
                  newCoordinate.Provincia = res.Provincia;

                  ElementsEditComponent._this.elemEdit.Coordenadas.push(newCoordinate);
                  ElementsEditHistoricoCoordenadasComponent._this.elemEdit.Coordenadas.sort((a, b) => a.Fecha < b.Fecha ? 1 : -1);
                  ElementsEditHistoricoCoordenadasComponent._this.gridHistCoordenadas.updatebounddata();
                }
                MainComponent.getInstance().showSuccess('ATENCION', 'Registro_almacenado', 2000);
              } else {
                MainComponent.getInstance().showError('ATENCION', 'Fallo_almacenar_info', 2000);
              }
            },
            nzOnCancel: async () => {
              for (let i = 0; i < _this.elementList.length; i++) {
                if (_this.elementList[i].Id === marker.dataModel.Id) {
                  marker.setPosition(new MapLatLng(_this.elementList[i].Lat, _this.elementList[i].Lng));
                  break;
                }
              }
            }
          });
        }
      }
    }
  }

  // Añade un marcador al mapa
  addMarker(elem: ElementoModel, refresh = true): MapMarker {
    let icono = 'assets/images/elemento.png';
    if (!this.elementsService.elemGenericos && elem.Equipamiento.Icono && elem.Equipamiento.Icono.length > 50) {
      icono = 'data:image/png;base64,' + elem.Equipamiento.Icono;
    }
    return this.map.addMarkerClusterV2(this.elemCluster, {
      dataModel: elem,
      label: (elem.ImeiVolum || elem.IdVolumetrico) ? elem.UltPctjeVolum + '%' : '',
      title: this.getMarkerTitle(elem),
      content: this.getMarkerContent(elem),
      position: new MapLatLng(elem.Lat, elem.Lng),
      icon: icono,
      zIndex: 10,
      drag: (this.canMove && this.canEdit),
      visible: true
    }, refresh);
  }

  // Crea los componentes de la cabecera
  protected createToolBar(statusbar: any): void {
    if (statusbar[0] !== undefined && !ElementsComponent.getInstance().toolbarOk) {
      ElementsComponent.getInstance().toolbarOk = true;
      // Añado el control de búsqueda a la cabecera
      const toolbarContainer = document.createElement('div');
      toolbarContainer.style.cssText = 'overflow: hidden; position: relative; margin-left: 4px; margin-top: 0px';

      const searchControl = document.createElement('div');
      searchControl.id = 'searchControlElements';
      searchControl.style.cssText = `
        float: left;
        background-color: white;
        background-image: url('../assets/images/search.png');
        background-repeat: no-repeat;
        background-position: 4px center;
        background-size: 18px;
        display: flex;
        align-items: center;
        width: 206px;
        margin-top: 2px;
        padding-top: 2px;
        padding-left: 28px;
        height: 25px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        border-radius: 3px;
        overflow: hidden;
      `;

      searchControl.innerHTML = `
        <input type="text" style="border: 0;width: 100%; outline: none;" (keydown.enter)="$event.preventDefault()"
        placeholder="${AppComponent.translate('Buscar')}..." autocorrect = "off" autocapitalize = "off" spellcheck = "off">
      `;
      toolbarContainer.appendChild(searchControl);

      // Creo el botón para crear
      const btnCrear = document.createElement('div');
      btnCrear.id = 'btnCrear';
      btnCrear.style.cssText = 'float: left; height: 25px; width: 85px; padding-left: 3px; padding-top: 2px;';

      // Crear el botón con el atributo disabled si es necesario
      btnCrear.innerHTML = `
        <button type="submit" style="width: 80px; height: 25px; align-items: center;cursor: pointer;">
          <div style="float: right; padding-top: 2px;">${AppComponent.translate('Crear')}</div>
          <img style="float: left; height: 18px; width: 18px;" src="../assets/images/mas.png" />
        </button>
      `;
      toolbarContainer.appendChild(btnCrear);

      // Creo el botón para editar
      const btnEditar = document.createElement('div');
      btnEditar.id = 'btnEditar';
      btnEditar.style.cssText = 'float: left; height: 25px; width: 85px; padding: 2px;';
      btnEditar.innerHTML = `
        <button type="submit" style="width: 80px; height: 25px; align-items: center;cursor: pointer;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Editar') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/editar.png" /></button>
      `;
      toolbarContainer.appendChild(btnEditar);

      // Creo el botón para borrar
      const btnBorrar = document.createElement('div');
      btnBorrar.id = 'btnBorrar';
      btnBorrar.style.cssText = 'float: left; height: 25px; padding: 2px;';
      btnBorrar.innerHTML = `
        <button type="submit" style="height: 25px; align-items: center;cursor: pointer;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Borrar') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/borrar.png" /></button>
      `;
      toolbarContainer.appendChild(btnBorrar);

      const btnInstall = document.createElement('div');
      btnInstall.id = 'btnInstall';
      btnInstall.style.cssText = 'float: left; height: 25px; padding: 2px;';
      btnInstall.innerHTML = `
        <button type="button" title='` + AppComponent.translate('Instalaciones') + `'
          style=" height: 25px;">
          <i class="fa-solid fa-screwdriver-wrench"></i>
          <span style="margin-left: 5px;">` + AppComponent.translate('Instalaciones') + `</span>
        </button>
      `;
      toolbarContainer.appendChild(btnInstall);

      // Creo el check para activar el movimiento de elementos
      const btnMover = document.createElement('div');
      btnMover.id = 'btnMover';
      btnMover.style.cssText = 'float: left; height: 25px; width: 85px; padding: 2px;';
      btnMover.innerHTML = `
        <div style="float: left; margin-left: 4px; padding-top: 5px;">`+ AppComponent.translate('Mover') + `</div>
        <input type="checkbox" style="float:left; margin-left: 5px; margin-top: 5px; width: 16px; height: 16px;" />
      `;
      toolbarContainer.appendChild(btnMover);

      // Creo el botón para móviles cercanos
      const btnElementosCerca = document.createElement('div');
      btnElementosCerca.id = 'btnElementosCerca';
      btnElementosCerca.style.cssText = 'float: left; padding: 2px;display: inline-block;margin-right: 60px; ';
      btnElementosCerca.innerHTML = `
        <button type="submit"  style="height: 25px; align-items: center;cursor: pointer;">
        <div style="float: right; padding-top: 2px;">`+ AppComponent.translate('Cerca') + `</div>
        <img style="float: left; height: 18px; width: 18px;" src="../assets/images/radar.png" /></button>
      `;
      toolbarContainer.appendChild(btnElementosCerca);

      // Boton vista general
      const btnVistaGeneral = document.createElement('div');
      btnVistaGeneral.id = 'btnVistaGeneral';
      btnVistaGeneral.style.cssText = 'float: left; padding: 2px;';
      btnVistaGeneral.innerHTML = `
        <button type="submit" style="height: 25px; align-items: center;cursor: pointer;">
          <div style="float: right; padding-top: 2px;">
          <i class="fa fa-eye" aria-hidden="true"></i>
            ${AppComponent.translate('General')}
          </div>
        </button>
      `;
      toolbarContainer.appendChild(btnVistaGeneral);

      // Boton vista ecolock
      const btnVistaEcolock = document.createElement('div');
      btnVistaEcolock.id = 'btnVistaEcolock';
      btnVistaEcolock.style.cssText = 'float: left; padding: 2px;';
      btnVistaEcolock.innerHTML = `
        <button type="submit" style="height: 25px; align-items: center;cursor: pointer;">
          <div style="float: right; padding-top: 2px;">
          <i class="fa-solid fa-lock"></i>
            ${AppComponent.translate('Ecolock')}
          </div>
        </button>
      `;
      toolbarContainer.appendChild(btnVistaEcolock);


      // añado el boton exportar a excel
      const btnExportar = document.createElement('div');
      btnExportar.id = 'btnExportar';
      btnExportar.style.cssText = 'float: right; height: 25px;  padding: 2px; margin-left: 5px;';
      btnExportar.innerHTML = `
        <button type="submit" class='button' title='`+ AppComponent.translate('Exportar') + `' style="width: 35px; height: 25px; align-items: center; cursor: pointer;">
        <div style="float: right; padding-top: 2px;"></div>
        <i class="fa fa-file-excel fa-lg"></i></button>
      `;

      toolbarContainer.appendChild(btnExportar);

      statusbar[0].appendChild(toolbarContainer);

      // Creo los botones y el componente de búsqueda
      ElementsComponent.getInstance().initSearchControl();
      ElementsComponent.getInstance().initToolbarButtons();
    }
  }

  groupsrenderer(text?: string, group?: any, expanded?: boolean, data?: any): string {
    let showText = `
      <div style="top: 50%; margin-top: -8px; position: relative; margin-left: 4px">
    `;

    if (data) {
      if (data.groupcolumn) {
        showText += `<b>${data.groupcolumn.text}:</b>`;

        if (data.groupcolumn.datafield === 'volumetrico') {
          return null;
        }

        if (data.group) {
          if (data?.groupcolumn?.datafield === 'icono') {
            showText += `<img style="margin-left: 4px;" height="16" width="16" src="data:image/jpg;base64,` +
              data?.group +
              `"/>`;
          } else if (data?.groupcolumn?.datafield === 'fechaLectura') {
            const comparisonDate = new Date("Mon Jan 01 0001 00:00:00 GMT-0014");

            if (data?.subGroups.length !== 0) {
              if (data.subGroups[0].fechaLectura.getTime() !== comparisonDate.getTime() && data.subGroups[0].reqVolumetrico !== null) {
                showText += `<span class="jqx-grid-groups-row-details jqx-grid-groups-row-details-material"/>` +
                  DateUtils.formatDate(data?.group, true) + ` ` + DateUtils.formatTime(data?.group) +
                  `<span/>`;
              } else {
              }
            } else {
              if (data.subItems[0].fechaLectura.getTime() !== comparisonDate.getTime() && data.subItems[0].reqVolumetrico !== null) {
                showText += `<span class="jqx-grid-groups-row-details jqx-grid-groups-row-details-material"/>` +
                  DateUtils.formatDate(data?.group, true) + ` ` + DateUtils.formatTime(data?.group) +
                  `<span/>`;
              } else {
              }
            }
          } else if (data?.groupcolumn?.datafield === 'ecolock') {
            showText += `<span class="jqx-grid-groups-row-details jqx-grid-groups-row-details-material"/>` +
              DateUtils.formatDate(data?.group, true) + ` ` + DateUtils.formatTime(data?.group) +
              `<span/>`;
          } else {
            return null;
          }
        }

        if (data?.subGroups.length !== 0) {
          showText += '(' + data?.subGroups.length + ')';
        } else if (data.subItems.length !== 0) {
          showText += '(' + data?.subItems.length + ')';
        }
      }
    }
    return showText;
  }

  isWarningVisible = false;
  isConfirmationVisible = false;
  elementosConInstalacionIds = '';
  elementosSinInstalacion: any[] = [];

  // Inicializa los botones de la cabecera
  initToolbarButtons(): void {
    const btnCrear = document.getElementById('btnCrear');
    if (btnCrear) {
      btnCrear.addEventListener('click', (event: any) => {
        // Verificar si ya hay una instancia abierta de creación
        if (this.openCreateComponent && !this.openCreateComponent.closed) {
          // Traer el formulario existente al frente
          this.openCreateComponent.expandForm();
          return;
        }

        // Crear una nueva instancia del componente de creación
        const component = this.elementsContainer.createComponent(ElementsEditComponent);
        component.instance.init(component, null);
        this.openCreateComponent = component.instance;

      });
    }

    const btnEditar = document.getElementById('btnEditar');
    if (btnEditar) {
      btnEditar.addEventListener('click', (event: any) => {
        const rowsSelec = this.gridElements.getselectedrowindexes();
        if (rowsSelec && rowsSelec.length > 0) {
          if (rowsSelec.length < 11) {
            rowsSelec.forEach(rowIndex => {
              this.checkEditingElement(this.elementList[rowIndex]);
            });
          } else {
            MainComponent.getInstance().showWarning('ATENCION', 'Diez_registros_maximo', 2000);
          }
        } else {
          MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
        }
      });
    }

    const btnBorrar = document.getElementById('btnBorrar');
    if (btnBorrar) {
      btnBorrar.addEventListener('click', (event: any) => {
        const rowsSelec = this.gridElements.getselectedrowindexes();
        if (rowsSelec && rowsSelec.length > 0) {
          if (rowsSelec.length < 11) {
            rowsSelec.forEach(async (rowIndex) => {
              let result = await this.elementsService.getResiduoPendiente(this.elementList[rowIndex].Id);
              if (result.id || this.elementList[rowIndex]?.cerradura?.id) {

                MainComponent.getInstance().showWarning('ATENCION', 'Elemento_con_residuo', 3000, ' ' + this.elementList[rowIndex].Nombre);
                MainComponent.getInstance().showWarning('ATENCION', 'Elemento_con_cerradura', 3000, ' ' + this.elementList[rowIndex].Nombre);

              } else {
                this.modal.confirm({
                  nzTitle: '<i>' + AppComponent.translate('ATENCION') + '</i>',
                  nzContent: AppComponent.translate('Quiere_borrar_elemento') + ' ' + this.elementList[rowIndex].Nombre + ' ?',
                  nzCentered: true,
                  nzCancelText: AppComponent.translate('CANCELAR'),
                  nzOkText: AppComponent.translate('SI'),
                  nzOnOk: async () => {
                    await this.elementsService.deleteElemento(this.elementList[rowIndex]);
                    MainComponent.getInstance().showSuccess('ATENCION', 'Registro_borrado', 2000);
                    this.gridElements.clearselection();
                  }
                });
              }
            });
          } else {
            MainComponent.getInstance().showWarning('ATENCION', 'Diez_registros_maximo', 2000);
          }
        } else {
          MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
        }
      });
    }

    const btnMover = document.getElementById('btnMover');
    if (btnMover) {
      btnMover.addEventListener('click', (event: any) => {
        this.canMove = event.target.checked;
        if (this.elementList) {
          this.elementList.forEach(elem => {
            if (elem.Marker) {
              elem.Marker.setDraggable(this.canMove);
            }
          });
        }
      });
    }

    const btnMovilesCerca = document.getElementById('btnElementosCerca');
    if (btnMovilesCerca) {
      btnMovilesCerca.addEventListener('click', (event: any) => {
        const component = this.elementsContainer.createComponent(ElementsCercaComponent);
        component.instance.init(component);
      });
    }

    const btnAsignaciones = document.getElementById('btnInstall');
    if (btnAsignaciones) {
      btnAsignaciones.addEventListener('click', async () => {
        if (this.isProcessing) {
          return;
        }
        const btnInstall = document.querySelector('#btnInstall button') as HTMLButtonElement;
        btnInstall.disabled = true;
        btnInstall.classList.add('loading');
        this.isProcessing = true;

        const elementosSelectIndex = this.gridElements.getselectedrowindexes();
        if (elementosSelectIndex.length === 0) {
          this.isProcessing = false;
          btnInstall.disabled = false;
          btnInstall.classList.remove('loading');
          return MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);

        }

        const elementos = elementosSelectIndex.map(index => this.elementList[index]);

        try {
          const resultados = await Promise.all(
            elementos.map(async (element) => {
              try {
                const instalacion = await this.instalacionService.getInstalacionByElement(element.Id);

                const tieneInstalacion =
                  (instalacion.instalaciones && instalacion.instalaciones.length > 0) ||
                  instalacion.requiereInstalacionCerradura ||
                  instalacion.requiereInstalacionIdentificador ||
                  instalacion.requiereInstalacionTag ||
                  instalacion.requiereInstalacionVolumetrico ||
                  instalacion.id > 0;

                return { ...element, tieneInstalacion };
              } catch (error) {
                console.error(error);
                return { ...element, tieneInstalacion: false };
              }
            })
          );

          const elementosConInstalacion = resultados.filter(el => el.tieneInstalacion);
          this.elementosSinInstalacion = resultados.filter(el => !el.tieneInstalacion);

          if (elementosConInstalacion.length === elementos.length) {
            this.isWarningVisible = true;
            return;
          }

          if (elementosConInstalacion.length > 0) {
            this.elementosConInstalacionIds = elementosConInstalacion.map(el => el.Id).join(', ');
            this.isConfirmationVisible = true;
            return;
          }

          this.procesarElementos(this.elementosSinInstalacion);
        } finally {
          this.isProcessing = false;
          btnInstall.disabled = false;
          btnInstall.classList.remove('loading');
        }
      });
    }

    const btnVistaEcolock = document.getElementById('btnVistaEcolock');
    if(btnVistaEcolock) {
      btnVistaEcolock.addEventListener('click', () => {
        if(this.vista !== VISTAS.ECOLOCK) {
          this.vista = VISTAS.ECOLOCK;
          this.elementListEcolockView = this.elementList.filter(element => element.cerradura.id !== 0);

          this.source.localdata = this.elementListEcolockView;
          btnVistaEcolock.classList.add('button-vista-seleccionada');
          btnVistaGeneral.classList.remove('button-vista-seleccionada');
        }

        this.gridElements.updatebounddata('data');

        this.adjustColumnVisibility();
      })
    }

     const btnVistaGeneral = document.getElementById('btnVistaGeneral');
     btnVistaGeneral.classList.add('button-vista-seleccionada');
    if(btnVistaGeneral) {
      btnVistaGeneral.addEventListener('click', () => {
        if(this.vista !== VISTAS.NORMAL) {
          this.vista = VISTAS.NORMAL;

          this.source.localdata = this.elementList;
          btnVistaGeneral.classList.add('button-vista-seleccionada');
          btnVistaEcolock.classList.remove('button-vista-seleccionada');
        }

        this.gridElements.updatebounddata('data');

        this.adjustColumnVisibility();
      })
    }

    //boton exportar
    const btnExportar = document.getElementById('btnExportar');
    if (btnExportar) {
      btnExportar.addEventListener('click', () => {
        this.exportService.exportFile(
          this.gridElements,
          DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Elementos') + '.xlsx'
        );
      });
    }
  }

  handleConfirm() {
    this.isConfirmationVisible = false;
    this.procesarElementos(this.elementosSinInstalacion);
  }

  handleCancel() {
    this.isConfirmationVisible = false;
    this.isWarningVisible = false;
  }

  handleWarningOk() {
    this.isWarningVisible = false;
  }

  procesarElementos(elementos: any[]) {
    const component = this.elementsContainer.createComponent(ElementInstallOptionsComponent);
    component.instance.init(component, elementos);
  }

  generateAutofilterHeader(sheet) {
    // Añade filtro a todas las casillas.
    sheet['!autofilter'] = { ref: sheet['!ref'] };
  }

  // Inicializa el control de búsqueda de la cabecera
  initSearchControl(): void {
    const searchControl = document.getElementById('searchControlElements');
    if (searchControl) {
      let lastSearch = '';
      let timer = null;

      searchControl.addEventListener('input', (event: any) => {
        this.searchText = event.target.value;
      });

      setInterval(() => {
        if (this.searchText !== lastSearch) {
          if (timer) {
            clearTimeout(timer);
          }
          lastSearch = this.searchText;
          timer = setTimeout(() => {
            if (this.elementList) {
              this.elementList.forEach(elem => {
                if ((elem.Equipamiento.Marca.Nombre && elem.Equipamiento.Marca.Nombre.compareWith(this.searchText)) ||
                  (elem.Equipamiento.Modelo.Nombre && elem.Equipamiento.Modelo.Nombre.compareWith(this.searchText)) ||
                  (elem.Equipamiento.Elemento.Nombre && elem.Equipamiento.Elemento.Nombre.compareWith(this.searchText)) ||
                  (elem.Equipamiento.Elemento.Tipo.Nombre && elem.Equipamiento.Elemento.Tipo.Nombre.compareWith(this.searchText)) ||
                  (elem.Nombre && elem.Nombre.compareWith(this.searchText)) ||
                  (elem.NumeroCalle && elem.NumeroCalle.compareWith(this.searchText)) ||
                  (elem.Calle && elem.Calle.compareWith(this.searchText)) ||
                  (elem.CodigoPostal && elem.CodigoPostal.compareWith(this.searchText)) ||
                  (elem.Poblacion && elem.Poblacion.compareWith(this.searchText)) ||
                  (elem.Provincia && elem.Provincia.compareWith(this.searchText)) ||
                  (elem.Pais && elem.Pais.compareWith(this.searchText)) ||
                  (elem.ComunidadAutonoma && elem.ComunidadAutonoma.compareWith(this.searchText)) ||
                  (elem.Municipio && elem.Municipio.compareWith(this.searchText))
                ) {
                  elem.selec = 'selec';
                } else {
                  elem.selec = '';
                }
              });
            }

            const filters = this.gridElements.getfilterinformation();
            if (filters.find(s => s.datafield === 'selec') === undefined) {
              const filtergroup = new jqx.filter();
              filtergroup.addfilter(1, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
              this.gridElements.addfilter('selec', filtergroup);
            }
            this.gridElements.applyfilters();
            this.gridElements.updatebounddata('data');
          }, 200);
        }
      }, 200);
    }
  }

  // Cuando se destruye el componente borro las subscripciones y los temporizadores
  ngOnDestroy() {
    if (this.subscriptionOnAddElements) {
      this.subscriptionOnAddElements.unsubscribe();
    }
    if (this.subscriptionOnModifyElements) {
      this.subscriptionOnModifyElements.unsubscribe();
    }
    if (this.subscriptionOnDeleteElements) {
      this.subscriptionOnDeleteElements.unsubscribe();
    }
    if (this.subscriptionOnChangeFilterElements) {
      this.subscriptionOnChangeFilterElements.unsubscribe();
    }
    if (this.subscriptionOnNewElements) {
      this.subscriptionOnNewElements.unsubscribe();
    }
    if (this.subscriptionOnEndLoadElements) {
      this.subscriptionOnEndLoadElements.unsubscribe();
    }
    if (this.subscriptionOnModifyPU) {
      this.subscriptionOnModifyPU.unsubscribe();
    }
    if (this.timerSearch === null) {
      clearInterval(this.timerSearch);
    }
  }

  onCellClick(event: any) {
    clearTimeout(this.clickTimer);  // Siempre limpiamos el temporizador con cada clic para reiniciar el proceso
    // Configuramos el temporizador
    this.clickTimer = setTimeout(() => {
      if (event.args.datafield !== 'acciones') {
        const rowSel = this.gridElements.getselectedrowindexes();
        if (rowSel && rowSel.length < 2) {
          this.gridElements.clearselection();
          this.gridElements.selectrow(event.args.rowindex);
        }
        this.elemSelec = this.elementList[event.args.rowindex];
        if (!event.args.fromCarto) {
          if (this.elemSelec) {
            if (!this.elemSelec.Marker) {
              this.elemSelec.Marker = this.addMarker(this.elemSelec);
            }
            this.map.setCenter(this.elemSelec.Marker.position);
            this.map.setZoom(this.MARKERS_ZOOM);
            this.elemSelec.Marker.setZIndex(999);
            this.elemSelec.Marker.animate(2850);
          }
        }
      }
    }, 500);  // 500 milisegundos de espera para determinar si es un clic individual
  }

  onRowdoubleclick(event: any) {
    clearTimeout(this.clickTimer);

    const rowSel = this.gridElements.getselectedrowindexes();
    if (rowSel && rowSel.length < 2) {
      this.gridElements.clearselection();
      this.gridElements.selectrow(event.args.rowindex);
    }
    this.elemSelec = this.elementList[event.args.rowindex];

    this.onCellClick(event);

    const btnEditar = document.getElementById('btnEditar');
    btnEditar.click();
  }

  public initGridData (): void {
    this.elementList.map((elem) => {
      elem.Calle = (elem.Calle || '') + ' ' + (elem.NumeroCalle || '');
    });

    this.gridElements.columnmenuopening(this.columnmenuopening);
    this.source.localdata = this.elementList;
    this.dataAdapter.dataBind();
    this.gridElements.updatebounddata();
  }

  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    let filterColumns = [
      'descripcion',
      'marca',
      'modelo',
      'residuo',
      'clases',
      'reqVolumetrico',
      'tag',
      'ecoNsMovisat',
      'ecolock',
      'calle',
      'codigoPostal',
      'numeroCalle',
    ];

    if (typeof cellValue === 'string') {
      cellValue = cellValue.normaliceAccents().toLowerCase();
    }

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }


  private openWindows: Map<number, ElementsEditComponent> = new Map();

  public async checkEditingElement(elemento: ElementoModel) {
    let instance = this.openWindows.get(elemento.Id);

    if (instance) {
      instance.form.expandWindow();
      instance.form.bringToFront();
      return;
    }

    const component = ElementsComponent.getInstance().elementsContainer.createComponent(ElementsEditComponent);
    instance = component.instance;
    instance.init(component, elemento);
    this.openWindows.set(elemento.Id, instance);

    await this.waitForJqxWindow(instance);

    instance.form.windowClosed.subscribe(() => this.openWindows.delete(elemento.Id));

    instance.form.windowCollapsed.subscribe(() => {
      this.openWindows.forEach((value) => {
        if (value !== instance) {
          value.form.bringToFront();
        }
      });
    });
  }

  private waitForJqxWindow(instance: ElementsEditComponent): Promise<void> {
    return new Promise((resolve) => {
      const checkWindow = () => instance.form ? resolve() : requestAnimationFrame(checkWindow);
      checkWindow();
    });
  }


  // Ajusto el menu del filtro en funcion de la posicion
  columnmenuopening(menu: any, datafield: any, height: any) {
    if (menu && menu[0]) {
      let menuElement = <HTMLElement>document.getElementById(menu[0].id);
      let areaGestion = <HTMLElement>document.getElementById('elemGrid').children[0];
      let column = ElementsComponent.getInstance().gridElements.getcolumn(datafield)['element'];
      let menuTop = 0;

      /* En caso de que vaya a sobresalir por debajo de la pantalla lo ajusto hacia arriba */
      if (height > areaGestion.offsetHeight) {
        menuTop = height - areaGestion.offsetHeight + 100;
        menuElement.parentElement.style.top = '-' + menuTop + 'px';
      }

      /* Ajuste del menu para que se vea el boton de filtro en el grid */
      setTimeout(() => {
        let columnPos = column.offsetLeft + column.offsetWidth;
        let menuWidth = menuElement.offsetWidth;

        if (columnPos + menuWidth >= areaGestion.offsetWidth) {
          menuElement.parentElement.style.left = '-20px';
        } else {
          menuElement.parentElement.style.left = '20px';
        }
        /*
          Recoge los desplegables del menu del filtro
          y le añade un evento al hacer click
        */
        let dropDownFilterList = document.getElementsByClassName('jqx-dropdownlist');
        let listBox = document.getElementsByClassName('jqx-listbox-container');

        let arrListFilter: any = Array.from(dropDownFilterList);
        let arrListBox: any = Array.from(listBox);

        arrListFilter.forEach((element, idx) => {
          element.addEventListener("click", function () {
            /*
              Si el desplegable va a sobresalir le ajusta el top
              para que aparezca por encima del boton desplegable
            */
            if (document.body.offsetHeight < (arrListBox[idx].offsetTop + arrListBox[idx].offsetHeight)) {
              arrListBox[idx].style.top = (arrListBox[idx].offsetTop - (arrListBox[idx].offsetHeight + 10)) + 'px';
            }
          });
        });

        /*
          Recoge los desplegable de calendario
          y añade un evento al hacer click
        */
        let calendarButton = document.getElementsByClassName('jqx-icon-calendar');
        let listCalendar = document.getElementsByClassName('jqx-calendar-container');

        let arrcalendarButton: any = Array.from(calendarButton);
        let arrlistCalendar: any = Array.from(listCalendar);

        arrcalendarButton.forEach((btn, idx) => {
          btn.parentElement.addEventListener("click", function () {
            /*
              Si el desplegable va a sobresalir le ajusta el top
              para que aparezca por encima del boton desplegable
            */
            if (document.body.offsetHeight < (arrlistCalendar[idx].offsetTop + arrlistCalendar[idx].offsetHeight)) {
              arrlistCalendar[idx].style.top = (arrlistCalendar[idx].offsetTop - (arrlistCalendar[idx].offsetHeight + 40)) + 'px';
            }
          })
        });
      }, 50);
    }
  };

  // Cuando se refrescan los datos del grid
  onBindingComplete(): void {
    try {
      const orderBy = this.orderBy.split(',')
      this.gridElements?.sortby(orderBy[0], orderBy[1]);

      if (this.initialFilter) {
        this.setStoredFilter();
      }

      const elemVisibles = new Map<number, number>();
      const rowsVisibles = this.gridElements.getrows();
      rowsVisibles?.forEach(row => {
        elemVisibles.set(row.id, row.id);
      });

      this.elementList?.forEach(elem => {
        if (elem.Marker) {
          elem.Marker.setVisible(elemVisibles.get(elem.Id) !== undefined);
        }
      });

      this.elementsService.recordCountElementsUpdate(this.gridElements.getrows().length);
      this.adjustColumnVisibility();
    } catch (e) {
      console.error(e);
    }
  }

  // Permite añadir elementos al mapa y al grid
  async subscribeOnAddElements(): Promise<void> {
    this.columns.forEach(column => {
      column.rendered = (element) => {
        Utils.tooltiprenderer(element)
      };
    });
    this.subscriptionOnAddElements = this.elementsService.addElementEmiter.subscribe(async elementos => {
      elementos.forEach(async elemento => {
        elemento.UltFechaVolum = new Date(elemento.UltFechaVolum);
        this.elementListTotal.push(elemento);
      });
    });
  }

  // Permite añadir un nuevo elemento al mapa y al grid
  async subscribeOnNewElements(): Promise<void> {
    this.subscriptionOnNewElements = this.elementsService.newElementEmiter.subscribe(async elemento => {
      elemento.UltFechaVolum = new Date(elemento.UltFechaVolum);
      elemento.Equipamiento = BdtService.equipamiento.get(elemento.IdEquipamiento);
      // Añado los agregados
      this.addAgregates(elemento);
      // Añado el marcador refrescando el cluster
      elemento.Marker = this.addMarker(elemento, true);

      // Verifica si el elemento ya existe en la lista
      const index = this.elementList.findIndex(e => e.Id === elemento.Id);
      if (index === -1) {
        // Si no existe, lo agregamos
        this.elementListTotal.push(elemento);
        this.elementList.push(elemento);
        // const newRowData = this.convertElementToGridRow(elemento); // Asegúrate de convertir el objeto a la estructura de fila que el grid necesita
        // this.gridElements.addrow(null, newRowData);
        this.gridElements.updatebounddata('data');
      } else {
        // Si ya existe, actualizamos sus propiedades
        this.elementList[index] = elemento;
        this.gridElements.updaterow(elemento.Id, this.convertElementToGridRow(elemento));
      }
      //this.gridElements.updatebounddata('data');
      // Actualizo la hash table

      this.adjustColumnVisibility();


      this.elementsService.elementos.set(elemento.Id, elemento);
    });

  }

  private convertElementToGridRow(element: ElementoModel): any {
    return {
      id: element.Id,
      eqId: element.Equipamiento?.Modelo?.Id,
      icono: element.Equipamiento?.Icono,
      descripcion: element.Nombre,
      marca: element.Equipamiento?.Marca?.Nombre,
      modelo: element.Equipamiento?.Modelo?.Nombre,
      residuo: element.Equipamiento?.ResiduosNombres,
      clases: element.Equipamiento?.ClasesNombre,
      reqVolumetrico: element.Volumetrico?.NombreDispositivo,
      fechaLectura: element.UltFechaVolum,
      volumetrico: element.UltPctjeVolum,
      reqTag: element.Tag?.Tag,
      tag: element.Tag?.Matricula,
      ecoNsFabricante: element.cerradura?.nsFabricante,
      ecoNsMovisat: element.cerradura?.nsMovisat,
      ecolock: element.cerradura?.fechaUltimaConexion,
      selec: element.selec
    };
  }

  public adjustColumnVisibility(): void {
    const elementList = this.elementList;

    if (!elementList || elementList.length === 0) {
      return;
    }

    let showVolumetricoColumn: boolean;
    let showEcoLockColumn: boolean;
    let showTagColumn: boolean;

    elementList.forEach(element => {
      showVolumetricoColumn ||= !!element.Volumetrico;
      showTagColumn ||= !!element.Tag?.UltFechaVolum;
      showEcoLockColumn ||= !!element.cerradura?.id
    })

    this.visibleColumns.forEach(column => {
      this.gridElements.hidecolumn(column);
    })

    this.visibleColumns = [];

    if (showVolumetricoColumn) {
      this.visibleColumns.push('reqVolumetrico');
      this.visibleColumns.push('volumetrico');
      this.visibleColumns.push('fechaLectura');
    }

    if (showTagColumn) {
      this.visibleColumns.push('reqTag');
      this.visibleColumns.push('tag');
    }

    if (this.vista === VISTAS.ECOLOCK) {
      this.visibleColumns.push('ecoNsFabricante');
      this.visibleColumns.push('ecoNsMovisat');
      this.visibleColumns.push('ecolock');
    }

    this.visibleColumns.forEach(columnName => {
      try {
        if (!Object.entries(this.gridElements.getstate().columns).length) {
          return;
        }

        this.gridElements.showcolumn(columnName);
      } catch (error) {
        console.error(error);
      }
    });
  }

  // Cuando se ha terminado de descargar los elementos
  public async subscribeOnEndLoadElements(): Promise<void> {
    this.subscriptionOnEndLoadElements = this.elementsService.endLoadElementsEmiter.pipe(
      switchMap(() => combineLatest([
        MainComponent.getInstance().mapIsReady,
        from(this.elementsService.getElementsEquip())
      ])),
    ).subscribe(async () => {
      this.equipModelFilter = await this.elementsService.getFilterModel();
      if (MainComponent.getInstance().isEcoEvolution) {
        this.equipModelFilterIA = await this.elementsService.getFilterModelIA();
      } else {
        this.equipModelFilterIA = null;
      }
      // Creo la lista de elementos filtrados
      this.elementList = [];
      let hayVolum = false;

      const elementMap = new Set();
      if (this.elementListTotal) {
        this.elementListTotal.forEach(elemento => {
          elemento.UltFechaVolum = new Date(elemento.UltFechaVolum);
          elemento.Equipamiento = BdtService.equipamiento.get(elemento.IdEquipamiento);
          if (elemento.Equipamiento) {
            if (!this.equipModelFilterIA || this.equipModelFilterIA.find(s => s.id === elemento.Equipamiento.Id) !== undefined) {
              if (this.equipModelFilter.find(s => s.id === elemento.Equipamiento.Id) !== undefined) {
                elemento.selec = '';
                // Añado los agregados
                this.addAgregates(elemento);
                // Añado el marcador sin refrescar el cluster
                elemento.Marker = this.addMarker(elemento, false);

                const comparisonDate = new Date("Mon Jan 01 0001 00:00:00 GMT-0014");
                if (elemento.UltFechaVolum.getTime() === comparisonDate.getTime() || !elemento.Volumetrico) {
                  elemento.UltFechaVolum = comparisonDate;
                  elemento.UltPctjeVolum = 0;
                }

                if (!elementMap.has(elemento.Id)) {
                  this.elementList.push(elemento);
                  elementMap.add(elemento.Id);
                }

                if (elemento.ImeiVolum || elemento.IdVolumetrico) {
                  hayVolum = true;
                }
              }
            }
          }
        });
      }

      if (hayVolum) {
        this.gridElements.showcolumn('nivel');
        this.gridElements.showcolumn('fechaNivel');
      }
      try {
        const t = setTimeout(() => {
          clearTimeout(t);
          this.elemCluster.refresh(false);
        }, 500);
      } catch (e) {
      }
      // Asigno la lista de elementos para los módulos externos que los necesiten
      MainComponent.getInstance().elementsList = this.elementList;
      this.initGridData();
      this.elementsService.recordCountElementsTotal(this.elementList.length);
      this.adjustColumnVisibility();
      this.showLoader = false;
    });
  }

  addAgregates(elemento: ElementoModel) {
    if (!elemento.Estado) {
      elemento.Estado = 0;
    }
    switch (elemento.Estado) {
      case 1:
        elemento.estadoTexto = this.translate('Ubicado');
        break;
      case 2:
        elemento.estadoTexto = this.translate('En_transito');
        break;
      default:
        elemento.estadoTexto = '';
    }
    elemento.Infogeo = '';
    if (elemento.Calle) {
      elemento.Infogeo += elemento.Calle;
      if (elemento.NumeroCalle) {
        elemento.Infogeo += ', ' + elemento.NumeroCalle;
      }
    }
    if (elemento.Municipio) {
      elemento.Infogeo += elemento.Infogeo.length > 0 ? (', ' + elemento.Municipio) : elemento.Municipio;
    }
    if (elemento.Provincia) {
      elemento.Infogeo += elemento.Infogeo.length > 0 ? (' (' + elemento.Provincia + ')') : elemento.Provincia;
    }
  }

  // Devuelve el contenido del infowindows del marcador
  getMarkerTitle(elemento: ElementoModel): string {
    return elemento.Nombre;
  }

  // Devuelve el contenido del infowindows del marcador
  getMarkerContent(elemento: ElementoModel): string {
    let res = '';
    if (!this.elementsService.elemGenericos) {
      res = '<b>' + elemento.Nombre + '</b><hr>' + elemento.Equipamiento.Elemento.Nombre + '<br>' +
        (elemento.Equipamiento.Marca.Nombre ? elemento.Equipamiento.Marca.Nombre + '<br>' : '') +
        (elemento.Equipamiento.Modelo.Nombre ? elemento.Equipamiento.Modelo.Nombre : '');
      // Volumétricos
      if (elemento.ImeiVolum || elemento.IdVolumetrico) {
        res += '<br><br>' + this.translate('Nivel') + ': ' + elemento.UltPctjeVolum + '%';
        if (elemento.UltFechaVolum && elemento.UltFechaVolum.getFullYear() > 2000) {
          res += ' a ' + DateUtils.formatDateTimeShort(new Date(elemento.UltFechaVolum), true);
        }
      }
    } else {
      res = '<b>' + elemento.Nombre + '</b><hr>' + elemento.Equipamiento.Elemento.Nombre;
    }
    // Estados
    if (!elemento.Estado) {
      elemento.Estado = 0;
    }
    switch (elemento.Estado) {
      case 1:
        elemento.estadoTexto = this.translate('Ubicado');
        break;
      case 2:
        elemento.estadoTexto = this.translate('En_transito');
        break;
      default:
        elemento.estadoTexto = '';
    }
    res += '<br><b>' + elemento.estadoTexto + '</b>';
    return res;
  }

  // Permite saber que se han modificado elementos
  subscribeModifyElements(): void {
    this.subscriptionOnModifyElements = this.elementsService.modifyElementEmiter.subscribe(async elemento => {
      if (this.elementList) {
        for (let i = 0; i < this.elementList.length; i++) {
          // Actualizo los datos del elemento en la lista
          if (this.elementList[i].Id === elemento.Id) {
            const marker = elemento.Marker ? elemento.Marker : this.elementList[i].Marker;
            this.elementList[i] = elemento;
            elemento.Marker = marker;
            elemento.UltFechaVolum = new Date(elemento.UltFechaVolum);
            elemento.Equipamiento = BdtService.equipamiento.get(elemento.IdEquipamiento);
            if (elemento.Equipamiento) {
              if (!this.equipModelFilterIA || this.equipModelFilterIA.find(s => s.id === elemento.Equipamiento.Id) !== undefined) {
                if (this.equipModelFilter.find(s => s.id === elemento.Equipamiento.Id) !== undefined) {
                  elemento.selec = '';
                }
              }
            }
            // Actualizo los datos en el marcador
            if (marker) {
              this.elementList[i].Marker.setTitle(this.getMarkerTitle(elemento));
              this.elementList[i].Marker.setContent(this.getMarkerContent(elemento));
              this.elementList[i].Marker.setPosition(new MapLatLng(elemento.Lat, elemento.Lng));
            }
            // Añado los agregados
            this.addAgregates(this.elementList[i]);
            if (!elemento.PU) {
              // Compruebo si el elemento modificado ya tiene asignado el PU
              elemento.PU = await this.puService.getPuntoUbicacionByElemento(elemento.Id);
            }
            break;
          }
        }
      }

      this.elemCluster.refresh(false);
      // Actualizo el grid sólo después de haber asignado el dataadapter
      if (this.dataAdapter) {
        this.gridElements.updatebounddata('data');
        //this.initGrid();
      }
      // Actualizo la hash table
      this.elementsService.elementos.set(elemento.Id, elemento);
      this.adjustColumnVisibility();
    });
  }

  // Permite saber que se han borrado elementos
  subscribeDeleteElements(): void {
    this.subscriptionOnDeleteElements = this.elementsService.deleteElementEmiter.subscribe(async elemento => {
      if (this.elementList) {
        for (let i = 0; i < this.elementList.length; i++) {
          if (elemento.Id === this.elementList[i].Id) {
            this.map.removeMarker(elemento.Marker);
            this.elementList.splice(i, 1);
            this.elemCluster.refresh(true);
            // Actualizo el grid sólo después de haber asignado el dataadapter
            if (this.dataAdapter) {
              // actualizo el grid
              this.gridElements.updatebounddata('data');
              this.adjustColumnVisibility();
            }
            break;
          }
        }
      }
      if (this.elementListTotal) {
        for (let i = 0; i < this.elementListTotal.length; i++) {
          if (elemento.Id === this.elementListTotal[i].Id) {
            this.map.removeMarker(this.elementListTotal[i].Marker);
            this.elementListTotal.splice(i, 1);
            break;
          }
        }
      }
      // Actualizo la hash table
      this.elementsService.elementos.delete(elemento.Id);

    });
  }

  // Cuando se cambia el filtro de elementos
  async subscribeChangeFilterElements(): Promise<void> {
    this.subscriptionOnChangeFilterElements = this.elementsService.changeFilterEmiter.subscribe(async () => {
      this.equipModelFilter = await this.elementsService.getFilterModel();
      if (MainComponent.getInstance().isEcoEvolution) {
        this.equipModelFilterIA = await this.elementsService.getFilterModelIA();
      } else {
        this.equipModelFilterIA = null;
      }

      this.clearExistingMarkers();

      this.map.removeClusterV2(this.elemCluster);
      this.elemCluster = this.map.addClusterV2(this.MARKERS_ZOOM);

      this.elementList = [];
      this.elementListTotal.forEach(elemento => {
        if (elemento.Equipamiento) {
          const isInFilterIA =
            !this.equipModelFilterIA || this.equipModelFilterIA.find(s => s.id === elemento.Equipamiento.Id) !== undefined;
          const isInFilter = this.equipModelFilter.find(s => s.id === elemento.Equipamiento.Id) !== undefined;

          if (isInFilterIA && isInFilter) {
            elemento.selec = '';
            elemento.Marker = this.addMarker(elemento, false);
            this.elementList.push(elemento);
          }
        }
      });

      MainComponent.getInstance().elementsList = this.elementList;
      this.initGridData();
      this.elemCluster.refresh(false);
    });
  }

  private clearExistingMarkers(): void {
    this.elementList.forEach(elemento => {
      if (elemento.Marker) {
        this.map.removeMarker(elemento.Marker);
        elemento.Marker = null;
      }
    });
  }

  // Cando se crea un filtro
  async onChangeFilter(event: any) {
    this.initialFilter = null;
    let filter = null;
    // Si el primer filtro es el de la búsqueda busco el siguiente filtro
    let columnFilter = event.args.filters[0] ? event.args.filters[0].datafield : '';
    if (columnFilter === 'selec') {
      if (event.args.filters[1]) {
        // Si hay un segundo filtro es por que se han filtrado por alguna columna
        columnFilter = event.args.filters[1].datafield
        filter = event.args.filters[1].filter.getfilters();
      }
    } else {
      filter = event.args.filters[0] ? event.args.filters[0].filter.getfilters() : null;
    }
    // Si ha cambiado el filtro
    if (this.oldFilter !== filter) {
      this.oldFilter = filter;
      // Si no hay filtro pongo la variable en blanco
      if (!filter) {
        // Guardo la variable de configuración en blanco
        this.configService.setUsuEmpApp('elements-filters', '');
      } else {
        const config = {
          column: columnFilter,
          filters: filter
        }
        // Guardo la variable de configuración con los datos del filtro
        this.configService.setUsuEmpApp('elements-filters', JSON.stringify(config));
      }
      // Para que se repinten los cluster
      this.onBindingComplete();
    }
  }

  // '{"column":"subflota","filters":[{"value":"C.Lateral","condition":"EQUAL","operator":1,"type":"stringfilter"}]}'
  setStoredFilter() {
    // Recupero los datos del filtro guardado y los aplico
    const filtergroup = new jqx.filter();
    if (this.initialFilter && this.initialFilter.filters) {
      this.initialFilter.filters.forEach(elem => {
        const filter = filtergroup.createfilter(elem.type, elem.value, elem.condition);
        filtergroup.addfilter(elem.operator, filter);
      });
      this.gridElements.addfilter(this.initialFilter.column, filtergroup);
      this.gridElements.applyfilters();
      this.initialFilter = null;
    }
  }

  // Recupero el filtro guardado si lo hay
  async getInitFilter() {
    this.initialFilter = await this.configService.getUsuEmpApp('elements-filters', null);
    if (this.initialFilter) {
      this.initialFilter = JSON.parse(this.initialFilter);
    }
  }

  // Permite refrescar el grid de elementos
  public async refreshGrid() {
    setTimeout(() => {
      this.gridElements.updatebounddata('data');
      this.gridElements.ensurerowvisible(0);
    }, 500);
  }

  // Permite modificar la columna de ordenación y la dirección
  public async orderByGrid(column: string, order: string) {
    setTimeout(() => {
      this.orderBy = column + ',' + order;
      this.gridElements.updatebounddata('cell');

      this.gridElements.ensurerowvisible(0);
    }, 500);
  }

  // Permite visualizar u ocultar columnas del grid
  public showColumnGrid(column: string, show: boolean) {
    if (show) {
      this.gridElements.showcolumn(column);
    } else {
      this.gridElements.hidecolumn(column);
    }
  }

  // Cuando se modifica un punto de ubicación
  subscribeModifyPU(): void {
    this.subscriptionOnModifyPU = this.puService.modifyPuEmiter.subscribe(pu => {
      if (pu.Elemento && this.elementList) {
        for (let i = 0; i < this.elementList.length; i++) {
          if (this.elementList[i].Id === pu.Elemento.Id) {
            if (this.elementList[i].Marker) {
              this.elementList[i].Lat = pu.Lat;
              this.elementList[i].Lng = pu.Lng;
              this.elementList[i].Marker.setPosition(new MapLatLng(pu.Lat, pu.Lng));
            }
            this.elementsService.elementos.set(this.elementList[i].Id, this.elementList[i]);
            break;
          }
        }
      }
    });
  }

  // Permite asignar la distancia a la que se buscan móviles cerca
  public setDistanciaCerca(distancia: number) {
    this.distCerca = distancia;
  }
}
